/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from 'zod';

import {conversationDetail} from '../../modules/conversation/conversationDetail';
import {conversationParams} from '../../modules/conversation/conversationParams';
import {userIdParams} from '../../modules/user/userIdParams';

export const removeUserFromConversationParams = conversationParams.merge(userIdParams);

export type RemoveUserFromConversationParams = z.infer<typeof removeUserFromConversationParams>;

export const removeUserFromConversationResponse = conversationDetail;

export type RemoveUserFromConversationResponse = z.infer<typeof removeUserFromConversationResponse>;
